import React, { useState } from 'react';
import cx from 'classnames';
import ReactPlayer from 'react-player';
import { useDispatch } from 'react-redux';

import video from 'assets/video/MBP2.mp4';
import myImg from 'assets/images/MainLanding/my.svg';
import { AppDispatch } from 'redux/store';
import { saveRepresentChoise } from 'redux/reducers/communicationSlice';
import { LandingStatisticProfileType } from 'api/backofficeApiClient';

const REPRESENT_BUTTONS = [
  {
    id: LandingStatisticProfileType.IndependentRecruiter,
    btnContent: (
      <>
        Staffing Firm / <br />
        Independent Recruiter
      </>
    ),
  },
  {
    id: LandingStatisticProfileType.IndependentConsultant,
    btnContent: (
      <>
        gig worker / <br />
        independent consultant
      </>
    ),
  },
  {
    id: LandingStatisticProfileType.CorporateTAEntity,
    btnContent: (
      <>
        corporate talent <br />
        acquisition entity
      </>
    ),
  },
];

export default function WeAreSection() {
  const dispatch: AppDispatch = useDispatch();
  const [
    activeButton,
    setActiveButton,
  ] = useState<LandingStatisticProfileType>();
  const [isVideoPlayed, setIsVideoPlayed] = useState(false);
  const [isVideoPlaying, setIsVideoPlaying] = useState(false);

  const handleVideoPlay = () => {
    setIsVideoPlaying(true);
    setIsVideoPlayed(true);
  };

  const handleVideoPause = () => setIsVideoPlaying(false);

  const handleRepresentClick = (id: LandingStatisticProfileType) => {
    setActiveButton(id);

    dispatch(saveRepresentChoise(id));
  };

  return (
    <section className="we-are-section">
      <div className="wrapper">
        <div className="container">
          <div className="title my-title">
            <span>We are</span>

            <img src={myImg} alt="" />

            <span>Basepay</span>
          </div>
        </div>

        <div className="video-box">
          {!isVideoPlayed && !isVideoPlaying && (
            <button onClick={handleVideoPlay} className="video-play">
              <span className="icon icon-play"></span>
            </button>
          )}

          <ReactPlayer
            width="100%"
            height="auto"
            controls={isVideoPlayed}
            url={video}
            playing={isVideoPlaying}
            onPlay={handleVideoPlay}
            onPause={handleVideoPause}
          />
        </div>

        <div className="sub-title">
          <div className="sub-title-holder">
            Click below on what best represents you
          </div>
        </div>

        <div className="container">
          <div className="btn-row">
            {REPRESENT_BUTTONS.map(({ id, btnContent }) => (
              <div className="btn-col" key={id}>
                <button
                  disabled={!!activeButton}
                  onClick={() => handleRepresentClick(id)}
                  className={cx('btn size-lg', {
                    'primary-btn': activeButton !== id,
                    'outlined-btn': activeButton === id,
                  })}
                >
                  {activeButton === id ? (
                    <span className="icon icon-like" />
                  ) : (
                    <span>{btnContent}</span>
                  )}
                </button>
              </div>
            ))}
          </div>
        </div>
      </div>
    </section>
  );
}
